/* Uebernommen aus der Content-Factory (components/loading-animation/finalization-spinner.tsx), Auftrag
   2026-10-13. Inline-SVG mit eigenen Keyframes, Farben aus EDS-Tokens. */
import type { CSSProperties } from 'react';

type SpinnerProps = {
  speed?: number;
  className?: string;
  style?: CSSProperties;
  label?: string;
};

const KEYFRAMES = `
@keyframes cfTick1 { 0%,6% { stroke-dashoffset: 20; opacity: 1; } 18%,84% { stroke-dashoffset: 0; opacity: 1; } 92%,100% { stroke-dashoffset: 0; opacity: 0; } }
@keyframes cfTick2 { 0%,26% { stroke-dashoffset: 20; opacity: 1; } 38%,84% { stroke-dashoffset: 0; opacity: 1; } 92%,100% { stroke-dashoffset: 0; opacity: 0; } }
@keyframes cfTick3 { 0%,46% { stroke-dashoffset: 20; opacity: 1; } 58%,84% { stroke-dashoffset: 0; opacity: 1; } 92%,100% { stroke-dashoffset: 0; opacity: 0; } }
@keyframes cfPencil {
  0%,6% { transform: translate(87px,50px); }
  10% { transform: translate(91px,54px); }
  18% { transform: translate(98px,45px); }
  26% { transform: translate(87px,76px); }
  30% { transform: translate(91px,80px); }
  38% { transform: translate(98px,71px); }
  46% { transform: translate(87px,102px); }
  50% { transform: translate(91px,106px); }
  58% { transform: translate(98px,97px); }
  68%,86% { transform: translate(150px,70px); }
  100% { transform: translate(87px,50px); }
}
@media (prefers-reduced-motion: reduce) { [data-cf-spin] * { animation-play-state: paused !important; } }
`;

const ROWS = [
  { y: 50, line: 46, tick: 'cfTick1' },
  { y: 76, line: 36, tick: 'cfTick2' },
  { y: 102, line: 42, tick: 'cfTick3' },
];

export function FinalizationSpinner({ speed = 1, className, style, label }: SpinnerProps) {
  const dur = `${3.6 / speed}s`;

  return (
    <svg
      data-cf-spin="final"
      viewBox="0 0 240 170"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={className}
      style={{ width: '100%', maxWidth: '15.75rem', height: 'auto', overflow: 'visible', ...style }}
    >
      <style>{KEYFRAMES}</style>
      <rect
        x="16"
        y="130"
        width="208"
        height="7"
        rx="3.5"
        fill="var(--eds-semantic-color-gray-900)"
      />
      <rect
        x="72"
        y="24"
        width="96"
        height="106"
        rx="4"
        fill="var(--eds-semantic-color-background-primary)"
        stroke="var(--eds-semantic-color-gray-900)"
        strokeWidth="3"
      />
      <rect
        x="72"
        y="18"
        width="96"
        height="14"
        rx="4"
        fill="var(--eds-semantic-color-accent-primary-800)"
      />
      <path
        d="M88 10 L88 24 M104 10 L104 24 M120 10 L120 24 M136 10 L136 24 M152 10 L152 24"
        stroke="var(--eds-semantic-color-gray-900)"
        strokeWidth="3"
        strokeLinecap="round"
      />
      {ROWS.map((r) => (
        <g key={r.y}>
          <rect
            x="84"
            y={r.y - 8}
            width="16"
            height="16"
            rx="3"
            fill="var(--eds-semantic-color-background-primary)"
            stroke="var(--eds-semantic-color-gray-900)"
            strokeWidth="2.5"
          />
          <rect
            x="108"
            y={r.y - 2}
            width={r.line}
            height="4"
            rx="2"
            fill="var(--eds-semantic-color-gray-300)"
          />
          <path
            d={`M87 ${r.y} L91 ${r.y + 4} L98 ${r.y - 5}`}
            stroke="var(--eds-semantic-color-status-success-500)"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
            strokeDasharray="20"
            strokeDashoffset="20"
            style={{ animation: `${r.tick} ${dur} ease-out infinite` }}
          />
        </g>
      ))}
      <g style={{ animation: `cfPencil ${dur} ease-in-out infinite` }}>
        <g transform="rotate(-40)">
          <path
            d="M0 0 L10 -4 L10 4 Z"
            fill="var(--eds-semantic-color-surface-extended-warm-gray-subtle-hover)"
            stroke="var(--eds-semantic-color-gray-900)"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path d="M0 0 L4 -1.6 L4 1.6 Z" fill="var(--eds-semantic-color-gray-900)" />
          <rect
            x="10"
            y="-4"
            width="40"
            height="8"
            fill="var(--eds-semantic-color-accent-secondary-800)"
          />
          <rect x="50" y="-4" width="5" height="8" fill="var(--eds-semantic-color-gray-300)" />
          <rect
            x="55"
            y="-4"
            width="7"
            height="8"
            rx="2"
            fill="var(--eds-semantic-color-accent-primary-800)"
          />
        </g>
      </g>
    </svg>
  );
}
